<div class="modal-header">
    <h4 class="modal-title">İzin {{data.row ? 'Güncelle' : 'Ekle'}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
</div>
<div class="modal-body">
    <form [formGroup]="personLeaveForm">
        <div class="row">
            <div class="col-6">
                <label for="leaveDay">İzin gün sayısı</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="number" class="form-control" id="name" formControlName="leaveDay" />
                    </div>
                </div>
            </div>

            <div class="col-6">
                <label for="kindId">Başlangıç Seç</label>
                <div class="form-group">
                    <ng-select [items]="kinds" formControlName="kindId" placeholder="İzin türü seç" bindValue="id"
                        bindLabel="typeName"></ng-select>
                </div>
            </div>
            <div class="col-6">
                <label for="startDate">Başlangıç Seç</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime" formControlName="startDate"
                        [setDate]="date"></ng2-flatpickr>
                </div>
            </div>

            <div class="col-6">
                <label for="startDate">Bitiş Seç</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime" formControlName="endDate"
                        [setDate]="date2"></ng2-flatpickr>
                </div>
            </div>

            <div class="col-6" *ngIf="data.row">
                <label for="status">Durum</label>
                <div class="form-group">
                    <ng-select [items]="statusList" formControlName="status" placeholder="Durum seç" bindValue="id"
                        bindLabel="name"></ng-select>
                </div>
            </div>

        </div>

    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Hayır</button>
    <button type="button" class="btn btn-success" [disabled]="!personLeaveForm.valid" (click)="onSumbit()">{{data.row ?
        'Güncelle' : 'Kaydet'}}</button>
</div>